export enum MenuType {
    회사소개,
    서비스안내,
    상표등록,
    상표검색,
    절차안내,
    로그인,
    QnA,
}